import React, { useEffect, useState } from "react";
import { Box, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { genericFetchData } from "../../../../../../Services/Service";
import { checkNumberLimit } from "../../../../../../Utils/helper";

import ContactPerson from "./ContactPerson/ContactPerson";
import MuiButton from "../../../../../../Components/Button/Button";
import { AddNewTreatment } from "../Finance/Ip/Ip";
import WorkingHours from "./WorkingHours/WorkingHours";
import AddButton from "../../../../../../Components/AddButton/AddButton";
import Rejection from "../../../../../../Components/Details.jsx/Rejection";

function InsurancePage({ hospitalId, locationData, tabName }) {
  const [insuranceData, setInsuranceData] = useState({});
  const [insuranceDetails, setInsuranceDetails] = useState({
    contactPersonName: "",
    contactPersonNumber: null,
    fromWorkHr: "0",
    centerId: 0,
    hospitalTreatmentShares: [
      {
        mykareShare: "",
        price: "",
        treatmentId: 0,
      },
    ],
    insuranceTPAs: [
      {
        insuranceId: 0,
        tpaId: 0,
      },
    ],
    toWorkHr: "0",
  });

  const navigate = useNavigate();

  const [isEditable, setIsEditable] = useState(true);

  console.log(isEditable);

  const [treatments, setTreatments] = useState([]);

  const getAllTreatments = async () => {
    const response = await genericFetchData(`/treatments/all`, "GET");
    const status = response.status;
    const responseData = await response.json();
    if (status == 200) {
      setTreatments(responseData.treatments);
    } else {
      console.log("=======error", responseData);
    }
  };

  useEffect(() => {
    getAllTreatments();
    getAllInsurance();
    getAllTPAs();
    console.log("first");
  }, []);

  const [insurance, setInsurance] = useState([]);
  const [tpa, setTPA] = useState([]);
  const getAllInsurance = async () => {
    const response = await genericFetchData(`/insurance/all`, "GET");
    const status = response.status;
    const responseData = await await response.json();
    if (status == 200) {
      const data = responseData?.insurances?.map((val) => ({
        id: val.insuranceId,
        name: val.insuranceName,
      }));
      setInsurance(data);
    } else {
      console.log("=======error", responseData);
    }
  };

  const getAllTPAs = async () => {
    const response = await genericFetchData(`/tpa/all`, "GET");
    const status = response.status;
    const responseData = await response.json();
    if (status == 200) {
      const data = responseData?.map((val) => ({
        id: val.id,
        name: val.name,
      }));
      setTPA(data);
    } else {
      console.log("=======error", responseData);
    }
  };

  const handleDuplicate = () => {
    const newDuplicate = {
      mykareShare: "",
      price: "",
      treatmentId: 0,
    };
    setInsuranceDetails((prevDuplicates) => ({
      ...prevDuplicates,
      hospitalTreatmentShares: [
        ...prevDuplicates.hospitalTreatmentShares,
        newDuplicate,
      ],
    }));
  };

  const saveInternationalDetails = async () => {
    const hospitalTreatments = insuranceDetails.hospitalTreatmentShares.map(
      (val) => {
        return {
          mykareShare: val?.mykareShare,
          price: val?.price,
          treatmentId: val?.treatment ? val?.treatment?.id : val?.treatmentId,
        };
      }
    );
    const insuranceTPAs = insuranceDetails.insuranceTPAs.map((val) => {
      return { insuranceId: val?.insuranceId, tpaId: val?.tpaId };
    });
    const postData = {
      contactPersonName: insuranceDetails.contactPersonName,
      contactPersonNumber: insuranceDetails.contactPersonNumber,
      fromWorkHr: insuranceDetails.fromWorkHr,
      centerId: hospitalId,
      hospitalTreatmentShares: hospitalTreatments[0].mykareShare
        ? hospitalTreatments
        : [],
      insuranceTPAs: insuranceTPAs,
      // insuranceIds: insuranceDetails.insuranceIds,
      // tpdIds: insuranceDetails.tpdIds,
      toWorkHr: insuranceDetails.toWorkHr,
    };
    try {
      const response = await genericFetchData(
        `/center/insurance/save`,
        "POST",
        postData
      );
      const status = response.status;
      if (status === 200) {
        alert("saved successfully");
        setIsEditable(false);
        getHospitalInsuranceDetails();
        navigate("/hospital");
      } else {
        console.log("status======else===========", status);
      }
    } catch (error) {
      console.log("error=================", error);
    }
  };

  const getHospitalInsuranceDetails = async () => {
    try {
      const response = await genericFetchData(
        `/center/insurance?centerId=${hospitalId}&context=INSURANCE_TREATMENT_SHARE`,
        "GET"
      );
      const status = response.status;
      // setIsEditable(false);
      const responseData = await response.json();
      if (response.ok) {
        setIsEditable(false);
      }
      if (status === 200) {
        // navigate("/approvalsPending");
        setIsEditable(false);
        // const { treatmentShareResponses, insurances, tpaList, ...updatedData } =
        //   responseData;
        //   console.log(responseData,'from api inshu');
        //   setInsuranceDetails(responseData);
        // const data = insurances.map((val) => ({
        //   id: val.id,
        //   name: val.insuranceName,
        // }));
        // const list = tpaList.map((val) => ({
        //   id: val.id,
        //   name: val.name,
        // }));

        // setInsuranceDetails({
        //   ...updatedData,
        //   insurances: data,
        //   tpas: list,
        //   hospitalTreatmentShares: treatmentShareResponses?.length
        //     ? treatmentShareResponses
        //     : [
        //         {
        //           mykareShare: "",
        //           price: "",
        //           treatmentId: 0,
        //         },
        //       ],
        // });
        setInsuranceData(responseData);
      } else {
        console.log("=======error", status);
        setIsEditable(true);
      }
    } catch (error) {
      console.log("=======error", error);
      console.log("error bl");
    }
  };

  useEffect(() => {
    getHospitalInsuranceDetails();
  }, []);

  const { rejectedReason } = locationData?.locationData || {};
  const department = locationData?.locationData?.department?.trim();
  const activeTab = department?.toUpperCase() === tabName?.toUpperCase();

  return (
    <>
      {rejectedReason &&
        activeTab &&
        locationData?.locationData?.isEditable !== true && (
          <Rejection
            locationData={locationData}
            setIsEditable={setIsEditable}
          />
        )}
      <Box
        border={isEditable ? "none" : "1px solid lightgrey"}
        borderRadius={2}
        paddingX={5}
        paddingY={5}
      >
        <Grid
          container
          lg={12}
          justifyContent={"flex-end"}
          alignItems={"center"}
        >
          {/* <Grid item lg={1}>
          <Typography
            sx={{
              fontWeight: "600",
              fontSize: "16px",
              color: "#4c5a6a",
              paddingBottom: "20px",
              paddingTop: "20px",
            }}
          >
            Insurance
          </Typography>
        </Grid> */}
          {/* <Grid item lg={1.2} justifyContent={"flex-end"}>
          {!isEditable && (
            <MuiButton
              onClick={() => setIsEditable(true)}
              padding="10px 20px"
              viewHeight="30px"
              bgColor="#17dfba"
              borderRadius="50px"
              title={"Edit Details"}
              style={{ position: "absolute", top: "64px" }}
            />
          )}
        </Grid> */}
        </Grid>
        <ContactPerson
          isEditable={isEditable}
          insuranceData={insuranceData}
          setName={(value) =>
            setInsuranceDetails((s) => ({ ...s, contactPersonName: value }))
          }
          name={insuranceDetails.contactPersonName}
          setNumber={(value) => {
            const isNumber = checkNumberLimit(value);
            if (isNumber) {
              setInsuranceDetails((s) => ({
                ...s,
                contactPersonNumber: value,
              }));
            }
          }}
          number={insuranceDetails.contactPersonNumber}
        />
        <WorkingHours
          isEditable={isEditable}
          insurances={insurance}
          tpas={tpa}
          insuranceDetails={insuranceDetails}
          insuranceData={insuranceData}
          setInsuranceDetails={setInsuranceDetails}
        />
        {insuranceDetails?.hospitalTreatmentShares?.map((val, i) => {
          return (
            <AddNewTreatment
              isInsurance
              insuranceData={insuranceData}
              treatments={treatments}
              isEditable={isEditable}
              setPrice={(value) => {
                insuranceDetails.hospitalTreatmentShares[i].price = value;
                setInsuranceDetails((s) => ({
                  ...s,
                  hospitalTreatmentShares:
                    insuranceDetails.hospitalTreatmentShares,
                }));
              }}
              price={val.price}
              setShare={(value) => {
                insuranceDetails.hospitalTreatmentShares[i].mykareShare = value;
                setInsuranceDetails((s) => ({
                  ...s,
                  hospitalTreatmentShares:
                    insuranceDetails.hospitalTreatmentShares,
                }));
              }}
              share={val.mykareShare}
              setTreatment={(value) => {
                insuranceDetails.hospitalTreatmentShares[i].treatmentId =
                  value.id;
                setInsuranceDetails((s) => ({
                  ...s,
                  hospitalTreatmentShares:
                    insuranceDetails.hospitalTreatmentShares,
                }));
              }}
              treatment={val?.treatment}
              isCancel={i !== 0}
              onClose={() => {
                const updatedVal = [
                  ...insuranceDetails.hospitalTreatmentShares,
                ];
                updatedVal.splice(i, 1);
                setInsuranceDetails((s) => ({
                  ...s,
                  hospitalTreatmentShares: updatedVal,
                }));
              }}
            />
          );
        })}
        {isEditable && (
          <Grid item lg={12} justifyContent={"flex-end"} marginTop={"30px"}>
            <Grid item lg={1.1}>
              <AddButton
                onClick={handleDuplicate}
                labelName={"Add New"}
                viewHeight={"45px"}
                borderRadius={"5px"}
              />
            </Grid>
          </Grid>
        )}
        {isEditable && (
          <Grid
            item
            lg={12}
            container
            justifyContent={"flex-end"}
            marginTop={"30px"}
          >
            <Grid item lg={0.9}>
              <MuiButton
                onClick={saveInternationalDetails}
                padding="10px 30px"
                viewHeight="45px"
                bgColor="#17dfba"
                borderRadius="5px"
                title={"Save"}
              />
            </Grid>
          </Grid>
        )}
      </Box>
    </>
  );
}

export default InsurancePage;
